import { render, staticRenderFns } from "./DrawingImageConfig.vue?vue&type=template&id=ecc62254"
import script from "./DrawingImageConfig.vue?vue&type=script&lang=js"
export * from "./DrawingImageConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecc62254')) {
      api.createRecord('ecc62254', component.options)
    } else {
      api.reload('ecc62254', component.options)
    }
    module.hot.accept("./DrawingImageConfig.vue?vue&type=template&id=ecc62254", function () {
      api.rerender('ecc62254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/DrawingImageConfig.vue"
export default component.exports